import { render, staticRenderFns } from "./WikiControl.vue?vue&type=template&id=07327f6c&scoped=true"
import script from "./WikiControl.vue?vue&type=script&lang=js"
export * from "./WikiControl.vue?vue&type=script&lang=js"
import style0 from "./WikiControl.vue?vue&type=style&index=0&id=07327f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07327f6c",
  null
  
)

export default component.exports